import { Box, Button } from "@chakra-ui/react";
import { CustomModal } from "components/custom-modal";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { UpdateChangesContent } from "components/servicos-components/user-licences/modal-update-changes/update-changes-content";
import { useApplicationContext } from "contexts/ApplicationContext";
import { isColomboUser } from "utils/is-colombo-user";

const openMudancasUpdateModalEventName = "openMudancasUpdateModal";

export function ModalUpdateChanges() {
  const { isOpen, onClose } = useModalControls(
    openMudancasUpdateModalEventName
  );
  const { user } = useApplicationContext();
  const isColombo = isColomboUser(user);
  return (
    <CustomModal
      modalTitle={
        isColombo ? "Mudanças na cobrança" : "Mudanças na cobrança e cashback"
      }
      isOpen={isOpen}
      onClose={onClose}
      size="4xl"
      scroll="inside"
      modalFooter={
        <>
          <Button px={8} onClick={onClose}>
            Entendi
          </Button>
        </>
      }
    >
      <Box p={2}>
        <UpdateChangesContent />
      </Box>
    </CustomModal>
  );
}

export const openModalUpdateChanges = createModalTrigger(
  openMudancasUpdateModalEventName
);
